GP.GPMod('Content',function(self) {
    var vent  = null;
    var _util = null;
    var _log  = null;

    var _data = {
        // Used to track if there's an image in the queue
        media_input_status: false,
        fetching_likes: false,
        media_type: null,
        post_type: null, // status update or story

        content_collection: null, // public backbone content collection
        private_collection: null, // private backbone content collection

        profile_load_more: false,
        private_load_more: false,
        profile_fetching_content: false,

        // check and initialize a few params
        init: function() {
            vent  = self.vent;
            _util = self.app.Util;
            _log  = self.app.Util.log;

            _data.content_collection = new self.app.collections.Content();  // public content
            _data.private_collection = new self.app.collections.Content();  // private content
        }
    };

    // marionette collection views
    var _views = {
        public_cv:  null,  // public content collection view
        private_cv: null  // private content collection view
    };

    var util = {
        get_view_options: function(model, index) {
            var _grid_cookie = GP.sdata.my_user.view_type === 'grid' ? 1 : 0;
            if (GP.sdata.my_user.unconverted_trial || GP.sdata.my_user.membership === 'PENDING_FREE') {
                if (typeof self_profile_view != 'undefined' && self_profile_view) {
                    _grid_cookie = 0;
                }
            }
            return {
                view_cookie: _grid_cookie,
                childIndex:  index
            };
        }
    };

    var gui = {
        init: function() {
            this.$btn_profile_content     = $('#btn-profile-content');
            this.$content_file_input      = $('#content-file-input');
            this.$content_text_input      = $('#content-text-input');
            this.$content_private_option  = $('#content-private-option');
            this.$btn_post_content        = $('.btn-post-content');
            this.$post_char_wrap          = $('#char-wrap');
            this.$post_char_count         = $('#post-char-count');
            this.$alert_post_content      = $('.alert-post-content');
            this.$image_preview_wrap      = $('#image-preview-wrap');
            this.$btn_post_cancel         = $('.btn-post-cancel');
            this.$content_post_wrap       = $('.content-post-wrap');
            this.$btn_update_status       = $('.btn-update-status');

            this.$btn_add_story             = $('.btn-add-story');
            this.$content_story_title_input = $('#content-story-title-input');

            this.$content_post_btn_wrap   = $('.content-post-btn-wrap');
            this.$alert_success_video     = $('.alert-success-video');
            this.$alert_success_image     = $('.alert-success-image');
            this.$btn_content_view_toggle = $('.btn-content-view-toggle');

            this.$profile_content_media_region = $('#profile-content-media-region');
            this.$private_content_region       = $('#profile-private-content-region');
            this.$media_title_private          = $('.media-title-private');
            this.$btn_more_private_content     = $('#btn-more-private-content');
            this.$status_private_option        = $('.status-private-option');

            this.$private_media_request_wrap = $('.private-media-request-wrap');

            // hide the list/grid view buttons for unconverted trial users
            if (GP.sdata.my_user.unconverted_trial || GP.sdata.my_user.membership === 'PENDING_FREE') {
                $('.content-display-toggle').hide();
            }
        }
    };

    var apis = {
        add_content_text: function(content_text) {
            var post_data = {
                body: content_text
            };
            if (gui.$content_private_option.prop('checked')) {
                post_data.tags = 'PRIVATE';
            }
            self.api.post('/members/content/add_content_text', {
                data: post_data,
                success: function(json) {
                    handlers.update_view(json);
                }
            });
        },
        add_content_story: function(story, title) {
            var post_data = {
                story: story,
                title: title
            };
            if (gui.$content_private_option.prop('checked')) {
                post_data.tags = 'PRIVATE';
            }
            self.api.post('/members/content/add_content_story', {
                data: post_data,
                success: function(json) {
                    handlers.update_view(json);
                }
            });
        },
        decrement_likes: function(model) {
            $.post('/members/content/del_like', {
                content_id: model.get('content_id'),
                content_duid: model.get('duid'),
                content_gender: model.get('gender')
            }).done(function(data) {
                if (data.status) {
                    var new_count = parseInt(model.get('like_count'), 10) - 1;
                    model.set('is_liked', false);
                    model.set('like_count', new_count);
                    model.set('animate_heart', false);
                }
            });
        },
        increment_likes: function(model) {
            $.post('/members/content/add_like', {
                content_id: model.get('content_id'),
                content_duid: model.get('duid'),
                content_gender: model.get('gender'),
                content_type: model.get('content_type'),
                type: model.get('type')
            }).done(function(data) {
                if (data.status) {
                    var new_count = parseInt(model.get('like_count'), 10) + 1;
                    model.set('is_liked', true);
                    model.set('like_count', new_count);
                    model.set('animate_heart', true);
                } else if (data.error) {
                    _.each(data.error, function(err) {
                        if (GP.Util.check_obj(err) && err == 'billing_required') {
                            vent.trigger('Unlock:need_credits_modal');
                        }
                    });
                }
            });
        },
        add_comment: function(comment_data) {
            var comment_text = $.trim(comment_data.body);
            if (comment_text.length === 0) {
                return;
            }
            $.post('/members/content/add_comment', {
                content_id: comment_data.model.get('content_id'),
                content_gender: comment_data.model.get('gender'),
                content_type: comment_data.model.get('content_type'),
                content_duid: comment_data.model.get('duid'),
                parent_comment_id: comment_data.parent_comment_id,
                parent_comment_duid: comment_data.parent_comment_duid,
                type: comment_data.model.get('type'),
                body: comment_text
            }).done(function(data) {
                if (data.status) {
                    if(data.comment.parent_comment_id) {
                        comment_data.comment_model.get('replies').add({
                            content_id: comment_data.model.get('content_id'),
                            comment_duid: GP.sdata.my_user.duid,
                            comment_id: data.comment.comment_id,
                            parent_comment_id: data.comment.parent_comment_id,
                            url: GP.sdata.my_user.pic,
                            username: GP.sdata.my_user.username,
                            gender: GP.sdata.my_user.gender,
                            body: data.comment.body,
                            tag: data.comment.tag,
                            ctime: data.comment.ctime
                        });
                    }
                    else {
                        // Increment comment count
                        comment_data.model.set('comment_count', parseInt(comment_data.model.get('comment_count'), 10) + 1);
                        // Add comment to collection
                        comment_data.model.get('comments').add({
                            content_id: comment_data.model.get('content_id'),
                            comment_duid: GP.sdata.my_user.duid,
                            comment_id: data.comment.comment_id,
                            url: GP.sdata.my_user.pic,
                            username: GP.sdata.my_user.username,
                            gender: GP.sdata.my_user.gender,
                            body: data.comment.body,
                            tag: data.comment.tag,
                            ctime: data.comment.ctime
                        });
                    }
                } else if (data.error) {
                    //determine which model to use for error notices
                    var parent_model = (comment_data.parent_comment_id) ? comment_data.comment_model : comment_data.model;
                    _.each(data.error, function(err) {
                        if (GP.Util.check_obj(err) && err == 'throttled_hourly') {
                            parent_model.set('comment_throttled_hourly', true);
                        } else if (GP.Util.check_obj(err) && err == 'throttled_daily') {
                            parent_model.set('comment_throttled_daily', true);
                        } else if (GP.Util.check_obj(err) && err == 'id_throttled') {
                            parent_model.set('id_throttled', true);
                        } else if (GP.Util.check_obj(err) && err == 'billing_required') {
                            vent.trigger('Unlock:need_credits_modal');
                        } else {
                            parent_model.set('general_error', err);
                        }
                    });
                }
            });
        },
        delete_comment: function(model) {
            $.post('/members/content/del_comment', {
                content_id: model.get('content_id'),
                comment_id: model.get('comment_id'),
                comment_duid: model.get('comment_duid'),
                profile_duid: model.get('profile_duid')
            }).done(function(data) {
                if (data.status) {
                    handlers.remove_comment(model);
                }
            });
        },
        delete_content: function(model) {
            $.post('/members/content/del_content', {
                content_id: model.get('content_id'),
                membership: GP.sdata.my_user.membership,
                tags: model.get('tags')
            }).done(function(json) {
                if (json.status) {
                    if (model.get('tags').indexOf('PRIVATE') !== -1 || model.get('tags').indexOf('PRIVATE_ENFORCED') !== -1) {
                        handlers.remove_private_content(model);
                    } else {
                        handlers.remove_content(model);
                        // update if last pic was deleted
                        if (!_data.content_collection.findWhere({
                                type: 'IMAGE'
                        })) {
                            GP.sdata.my_user.has_pic = false;
                            vent.trigger('profile:handle_no_pics');
                        }
                    }
                    // check if we just deleted primary pic and update with new primary pic
                    if (json.main_media_pic) {
                        vent.trigger('profile:handle_primary_pic_set', json);
                    }

                    if (model.get('tags').indexOf('VIDEO_INTRO') !== -1) {
                        // close any modals that could be open (i.e. deleting video intro from modal)
                        vent.trigger('Modal:close');
                        $('.video-intro-wrap').remove();
                    }
                }
            });
        },
        get_more_comments: function(model, caller) {
            var last_id, first_comment = model.get('comments').first();

            if (typeof first_comment != 'undefined') {
                last_id = first_comment.get('comment_id');
            }

            if (!last_id) {
                return;
            }
            $.post('/members/content/get_comments', {
                content_id: model.get('content_id'),
                last_comment_id: last_id
            }).done(function(data) {
                if (data.status) {
                    model.set('from_ajax', true);
                    // Trigger deleted comments message.
                    if (data.has_deleted) {
                        model.set('has_deleted_comments', true);
                    }
                    if (data.comments.length) {
                        model.get('comments').add(data.comments);
                        // hide 'view more comments' link
                        if (!data.has_more) {
                            $('.btn-more-comments').hide();
                        }
                    } else {
                        // if for some reason comment_count doesn't correspond with actual comments.length
                        // and we get empty data.comments from api
                        // hide 'view more comments' link
                        $('.btn-more-comments').hide();
                    }
                    // Refresh nanoscroller in content viewer modal
                    if (typeof(caller) !== 'undefined' && caller == 'content_modal' && MoshPit.get_size() != 'mobile') {
                        vent.trigger('ContentViewerLayout:refresh_nanoscroller');
                    }
                }
            });
        },
        more_profile_content: function(caller) {
            if (!_data.profile_fetching_content) {
                _data.profile_fetching_content = true;

                $.post('/members/user/profile', {
                    duid: $('#profile-wrap').data('duid'),
                    last_content_id: _data.content_collection.last().get('content_id'),
                    get_content: 1
                }).done(function(json) {
                    _data.content_collection.add(json.content);

                    gui.$btn_profile_content.removeClass('btn-loading');

                    if (json.show_load_more === false) {
                        events.hide_profile_load_more();
                    }
                    _data.profile_load_more = json.show_load_more;
                    _data.profile_fetching_content = false;

                    // Trigger previous content if called from content viewer modal
                    if (typeof(caller) !== 'undefined' && caller == 'content_modal_prev') {
                        vent.trigger('ContentViewerLayout:prev_content');
                    }

                    // Trigger next content if called from content viewer modal
                    if (typeof(caller) !== 'undefined' && caller == 'content_modal') {
                        vent.trigger('ContentViewerLayout:next_content');
                    }
                });
            }
        },
        get_private_content: function(caller) {
            if (!_data.profile_fetching_content) {
                _data.profile_fetching_content = true;

                $.post('/members/user/profile', {
                    duid: $('#profile-wrap').data('duid'),
                    get_private_content: 1
                }).done(function(json) {
                    _data.private_collection.add(json.content);
                    gui.$private_media_request_wrap.addClass('hide');
                    if (json.show_load_more) {
                        events.btn_more_private_content('show');
                    }
                    _data.private_load_more = json.show_load_more;
                    _data.profile_fetching_content = false;

                    // Trigger next content if called from content viewer modal
                    if (typeof(caller) !== 'undefined' && caller == 'content_modal') {
                        vent.trigger('ContentViewerLayout:next_content');
                    }
                });
            }
        },
        more_private_content: function(caller) {
            if (!_data.profile_fetching_content) {
                _data.profile_fetching_content = true;

                $.post('/members/user/profile', {
                    duid: $('#profile-wrap').data('duid'),
                    last_content_id: _data.private_collection.last().get('content_id'),
                    get_private_content: 1
                }).done(function(json) {
                    _data.private_collection.add(json.content);
                    gui.$btn_more_private_content.removeClass('btn-loading');

                    if (json.show_load_more === false) {
                        events.btn_more_private_content('hide');
                    }
                    _data.private_load_more = json.show_load_more;
                    _data.profile_fetching_content = false;

                    // Trigger next content if called from content viewer modal
                    if (typeof(caller) !== 'undefined' && caller == 'content_modal') {
                        vent.trigger('ContentViewerLayout:next_content');
                    }
                });
            }
        },
        set_private: function(model) {
            $.post('/members/content/mod_private_content', {
                content_id: model.get('content_id'),
                action: 'PRIVATE'
            }).done(function(json) {
                if (json.status) {
                    handlers.remove_content(model);
                    model.set('tags', ['PRIVATE']);
                    handlers.add_private_content(model);
                    gui.$media_title_private.removeClass('hide');
                }
            });
        },
        set_public: function(model) {
            $.post('/members/content/mod_private_content', {
                content_id: model.get('content_id'),
                action: 'PUBLIC'
            }).done(function(json) {
                if (json.status) {
                    handlers.remove_private_content(model);
                    model.set('tags', []);
                    handlers.add_public_content(model);
                }
            });
        },
        mod_view_type: function(type) {
			var post_data = {
                type: type
            };
            self.api.post('/members/content/mod_view_type', {
                data: post_data,
                success: function(json) {
                }
            });
        }
    };

    var handlers = {
        add_private_content: function(model) {
            _data.private_collection.add(model);
        },
        add_public_content: function(model) {
            _data.content_collection.add(model);
        },
        remove_content: function(model) {
            model.set('fade_out', true);
            _data.content_collection.remove(model);
        },
        remove_private_content: function(model) {
            model.set('fade_out', true);
            _data.private_collection.remove(model);
        },
        remove_comment: function(model) {
            var content_id = model.get('content_id');

            // Find the model with matching content_id
            var content_model = _data.content_collection.findWhere({
                content_id: content_id
            });

            content_model.get('comments').remove(model);
            vent.trigger('CommentCounts:render');
        },
        update_view: function(json) {

            if (typeof json.error !== 'undefined' && json.error) {
                events.show_post_error(json.error);
                return;
            }

            if (_data.post_type == 'story' || _data.post_type == 'update') {
                events.reset_text_fields();
                events.reset_post_char_count();
                events.hide_post_box();
            }

            if (typeof self_profile_view !== 'undefined' && self_profile_view) {
                events.update_profile_feed(json);
            } else if (typeof home_view != 'undefined' && home_view) {
                vent.trigger('ContentHome:add_post', json);
            } else if (typeof feed_view !== 'undefined' && feed_view) {
                vent.trigger('ContentTrending:add_post', json);
            }

            if (json && json.primary_pic_set) {
                vent.trigger('profile:set_primary_pic', json.content_id, json.file_md5, json.content_media_id);
                GP.sdata.my_user.has_pic = true;
            }
        }
    };

    var events = {
        init: function() {
            vent.on('init_js:user:home init_js:user:profile init_js:content:trending init_js:content:pictures init_js:content:videos', events.setup_binds);

            // load profile media content when user profile is shown.
            vent.on(self.moduleName + ':init_profile_content', events.init_profile_content);

            // event to toggle "load more" button on profile
            vent.on(self.moduleName + ":hide_profile_load_more", events.hide_profile_load_more);

            vent.on(self.moduleName + ":decrement_likes", apis.decrement_likes);
            vent.on(self.moduleName + ":increment_likes", apis.increment_likes);
            vent.on(self.moduleName + ":add_comment", apis.add_comment);
            vent.on(self.moduleName + ":delete_comment", apis.delete_comment);
            vent.on(self.moduleName + ":delete_content", apis.delete_content);
            vent.on(self.moduleName + ":get_more_comments", apis.get_more_comments);
            vent.on(self.moduleName + ":update_profile_feed", events.update_profile_feed);
            vent.on(self.moduleName + ":animate_heart", events.animate_heart);
            vent.on(self.moduleName + ":toggle_auto_expand_comments", events.toggle_auto_expand_comments);
            vent.on(self.moduleName + ":update_like_count", events.update_like_count);
            vent.on(self.moduleName + ":update_comment_count", events.update_comment_count);
            vent.on(self.moduleName + ":more_profile_content", apis.more_profile_content);
            vent.on(self.moduleName + ":get_private_content", apis.get_private_content);
            vent.on(self.moduleName + ":more_private_content", apis.more_private_content);
            vent.on(self.moduleName + ":set_private", apis.set_private);
            vent.on(self.moduleName + ":set_public", apis.set_public);
            vent.on(self.moduleName + ":update_primary", events.update_primary);

            GP.reqres.setHandler(self.moduleName+':get_public_collection',  events.get_public_collection);
            GP.reqres.setHandler(self.moduleName+':get_private_collection', events.get_private_collection);
            GP.reqres.setHandler(self.moduleName+':get_profile_has_more',   events.get_profile_has_more);
            GP.reqres.setHandler(self.moduleName+':get_private_has_more',   events.get_private_has_more);
        },
        setup_binds: function() {
            // setup jquery selectors
            gui.init();

            // Load more profile content
            gui.$btn_profile_content.on('click', events.load_more_profile_content);
            gui.$btn_more_private_content.on('click', events.load_more_private_content);
            gui.$content_file_input.on('change', events.check_file_type);

            // Character counter on post input.
            gui.$content_text_input.on('keyup', function() {
                GP.Util.count_chars(gui.$content_text_input, gui.$post_char_count, events.get_max_chars());
            });

            gui.$content_text_input.on('paste', function() {
                // timeout fixes iOS reading textarea value.
                setTimeout(function() {
                    GP.Util.count_chars(gui.$content_text_input, gui.$post_char_count, events.get_max_chars());
                }, 300);
            });

            gui.$content_text_input.on('focus', function() {
                events.show_char_count();
            });

            gui.$btn_post_content.on('click', function() { 
                events.post_content();
                $('.content-display-toggle').show();
            });
            
            gui.$btn_post_cancel.on('click', function() { 
                events.hide_post_box();
                $('.content-display-toggle').show();
            });

            gui.$btn_content_view_toggle.on('click', events.content_view_toggle);

            $('#btn-video-banner').on('click', function() {
                gui.$content_file_input.click();
            });
            events.setup_profile_content_upload();

            gui.$btn_update_status.on('click', function() {
                events.show_post_box('update');
                $('.content-display-toggle').hide();
            });

            gui.$btn_add_story.on('click', function() {
                events.show_post_box('story');
            });
        },
        // populate public/private content collections when profile page is loaded (called from profile template)
        init_profile_content: function(public_content, private_content) {
            var pub = [], priv = [];
            home_view = false; // force false

            if ((typeof public_content != 'undefined' && public_content.content)) {
                pub = (public_content.content.length) ? public_content.content : [];
            }
            if ((typeof private_content != 'undefined' && private_content.content)) {
                priv = (private_content.content.length) ? private_content.content : [];
            }

            if (public_content.show_load_more) {
                _data.profile_load_more = public_content.show_load_more;
                events.show_profile_load_more();
            }
            if (private_content.show_load_more) {
                _data.private_load_more = private_content.show_load_more;
                events.btn_more_private_content('show');
            }

            // reset/populate public content collections
            _data.content_collection.reset(pub);
            _views.public_cv = new self.app.views.ContentList({
                el:         '#profile-content-media-region',
                collection: _data.content_collection,
                childViewOptions: util.get_view_options
            });

            // reset/populate private content collections
            _data.private_collection.reset(priv);
            _views.private_cv = new self.app.views.ContentList({
                el:         '#profile-private-content-region',
                collection: _data.private_collection,
                childViewOptions: util.get_view_options
            });

            // render the collection views for public/private content collections
            _views.public_cv.render();
            _views.private_cv.render();
        },
        load_more_profile_content: function(caller) {
            if (!_data.profile_fetching_content) {
                gui.$btn_profile_content.addClass('btn-loading');
                apis.more_profile_content();
            }
        },
        load_more_private_content: function(caller) {
            if (!_data.profile_fetching_content) {
                gui.$btn_more_private_content.addClass('btn-loading');
                apis.more_private_content();
            }
        },
        btn_profile_content_toggle: function() {
            $('.btn-more-reg-content-wrap').toggleClass('shown');
        },
        show_profile_load_more: function() {
            $('.btn-more-reg-content-wrap').addClass('shown');
        },
        hide_profile_load_more: function() {
            $('.btn-more-reg-content-wrap').removeClass('shown');
        },
        btn_more_private_content: function(action) {
            if (typeof action !== 'undefined') {
                var btn_more_private = $('.btn-more-priv-content-wrap');

                if (action == 'show') {
                    btn_more_private.addClass('shown');
                } else if (action == 'hide') {
                    btn_more_private.removeClass('shown');
                } else if (action == 'toggle') {
                    btn_more_private.toggleClass('shown');
                }
            }
        },
        check_file_type: function() {
            var file_input = $('#content-file-input')[0].files[0],
                image_types = /^image\/(gif|jpe?g|png|bmp)$/i,

                // This is for IE<10 because file mimetypes isn't defined in the file data
                image_names = /\.(gif|jpe?g|png|bmp)$/i,
                video_types = /^video\/(mp4|m4v|wmv|avi|mov|asf|quicktime|divx|ddat|webm|3gpp|x-flv|ogg|mpeg|mpg|flv)$/i,
                video_names = /\.(mp4|m4v|wmv|avi|mov|asf|ddat|webm|flv|3gp|ogv|mpeg|mpg|mpeg4|mp4v|divx|h264)$/i;

            if ((typeof(file_input.type) !== 'undefined' && image_types.test(file_input.type)) ||
                (typeof(file_input.name) !== 'undefined' && image_names.test(file_input.name))) {
                events.content_image_preview();
                _data.media_type = 'image';
            } else if ((typeof(file_input.type) !== 'undefined' && video_types.test(file_input.type)) ||
                (typeof(file_input.name) !== 'undefined' && video_names.test(file_input.name))) {
                events.show_post_box('video');
                _data.media_type = 'video';
            } else {
                events.show_post_error(js_lang.unacceptable_file_type);
            }
        },
        content_image_preview: function() {
            var file_reader = new FileReader();
            var image_file = $('#content-file-input')[0].files[0];
            events.reset_errors();

            if (image_file) {
                file_reader.readAsDataURL(image_file);
            }

            file_reader.onloadend = function() {
                events.show_post_box('photo');
                gui.$image_preview_wrap.addClass('shown');
                $('#content-image-preview').attr('src', file_reader.result);
            };
        },
        post_content: function() {
            // Check is there's an image in the queue
            if (_data.media_input_status) {
                // Add image
                events.post_content_media();
            } else {
                // Add text
                events.post_content_text();
            }
        },
        post_content_text: function() {
            var content_text = $.trim(gui.$content_text_input.val());

            if (content_text.length === 0) {
                return;
            }

            if (_data.post_type == 'story') {
                var story_title = $.trim(gui.$content_story_title_input.val());
                apis.add_content_story(content_text, story_title);
            } else {
                apis.add_content_text(content_text);
            }
        },
        post_content_media: function() {
            $('#btn-post-upload').click();
        },
        setup_profile_content_upload: function() {
            // file uploader (blueimp fileupload)
            $('#content-file-input').fileupload({
                url: '/members/user/upload_pic/',
                dataType:         'json',
                type:             'POST',
                autoUpload:       false,
                progressInterval: 50, // default 100ms
                bitrateInterval:  200,
                maxNumberOfFiles: 1,

// uploadTemplateId:   null,
// downloadTemplateId: null,

                add: function(e, upload_data) {
                    _data.media_input_status = true;

                    // Change upload url for videos
                    if (_data.media_type == 'video') {
                        upload_data.url = '/members/content/upload_video/';
                    }

                    // Cancel upload
                    gui.$btn_post_cancel.click(function(e) {
                        upload_data.abort();
                        events.reset_image_preview();
                        events.hide_post_box();
                    });

                    // Need to unbind first to clear the upload queue.
                    $('#btn-post-upload').off('click.post_content')
                    .on('click.post_content', function() {
                        // This doesn't exist in IE<10 will have to leave it for server side.
                        if (typeof(upload_data.originalFiles[0].size) !== 'undefined' && upload_data.originalFiles[0].size > upload_data.upload_max_size) {
                            events.show_post_error(js_lang.filesize_too_big);
                            return;
                        }

                        if (_data.media_type == null) {
                            return;
                        }

                        // no errors, go ahead with the upload
                        if (upload_data.errorThrown !== 'abort') {
                            upload_data.submit();
                        }
                    });
                },
                submit: function(e, data) {
                    // Send caption
                    var content_text = $.trim(gui.$content_text_input.val());
                    data.formData = {
                        ajax_request: true,
                        process: true,
                        content_post: true,
                        caption: content_text
                    };

                    if (gui.$content_private_option.prop('checked')) {
                        data.formData.tags = 'PRIVATE';
                    }
                },
                start: function(e) {
                    gui.$btn_post_content.addClass('loading');
                },
                done: function(e, json) {
                    if (!json || !json.hasOwnProperty('textStatus') || json.textStatus != 'success') {
                        // xhr error
                        // $('.error_container p').remove();
                        // $('.error_container').append('<p class="error">'+_modal_vars.error_messages[100]+'</p>').show();
                    } else if (typeof(json.result[0]) !== 'undefined' && json.result[0].hasOwnProperty('error')) {
                        // some other error coming back from image upload backend
                        events.reset_errors();
                        events.show_post_error(json.result[0].error);
                    } else if (json.result.error) {
                        _.each(json.result.error, function(err) {
                            events.show_post_error(err);
                        });
                    } else {
                        var content_data = {};
                        content_data = json.result[0];
                        events.reset_post_char_count();
                        events.reset_image_preview();

                        if (_data.media_type == 'video') {
                            events.show_video_upload_success();
                        } else {
                            if (GP.Util.check_location('/content/pictures') || GP.Util.check_location('/content/videos')) {
                                events.show_image_upload_success();
                            } else {
                                handlers.update_view(content_data);
                            }
                        }

                        events.hide_post_box();
                    }
                }
            });
        },
        update_profile_feed: function(json) {
            if (!_.isEmpty(json)) {
                if (GP.Util.check_obj(json.tags) && json.tags.indexOf('PRIVATE') !== -1) {
                    _data.private_collection.add(json);
                } else {
                    _data.content_collection.add(json);
                }

                // If uploading your first photo and viewing your own profile,
                // hide the no photos text div
                if (typeof self_profile_view != 'undefined' && self_profile_view) {
                    if (_data.content_collection.length == 1) {
                        $('.text-add-photos').hide();
                    }
                }
            }
        },
        update_private_feed: function(json) {},
        update_home_feed: function(json) {
            if (!_.isEmpty(json)) {
                json.gender = (GP.sdata.my_user.gender == 'MAN') ? 'M' : 'F';
                json.pic = GP.sdata.my_user.pic;

                _data.content_collection.add(json);
            }
        },
        show_post_error: function(error_message) {
            events.reset_errors();
            gui.$alert_post_content.append('<p>' + error_message + '</p>').show();

            setTimeout(function() {
                if (_data.post_type == 'story' || _data.post_type == 'update') {
                    gui.$alert_post_content.fadeOut();
                    events.reset_errors();
                } else {
                    gui.$alert_post_content.fadeOut();
                    events.hide_post_box();
                }
            }, 5000);
        },
        reset_errors: function() {
            gui.$alert_post_content.empty().css('display', 'none');
        },
        reset_image_preview: function() {
            // clear text input and hide image preview
            gui.$content_text_input.val('');
            gui.$image_preview_wrap.removeClass('shown');
            $('#content-image-preview').attr('src', '');
            _data.media_input_status = false;
        },
        reset_post_char_count: function() {
            gui.$post_char_count.text(events.get_max_chars());
            events.hide_char_count();
        },
        reset_text_fields: function() {
            gui.$content_text_input.val('');
            gui.$content_story_title_input.val('');
            events.reset_post_char_count();
        },
        toggle_auto_expand_comments: function($wrapper) {
            var cookie_name = 'cc_ae';
            var model_attr = true;
            var auto_expand_comments_cookie = parseInt($.cookie(cookie_name), 10);

            if (auto_expand_comments_cookie === 1) {
                $('.media-comment-region').addClass('hide');
                $('.more-comments-link-wrap').addClass('hide');
                _util.set_cookie(cookie_name, 0, 3);
                model_attr = true;
            } else {
                $('.media-comment-region').removeClass('hide');
                $('.more-comments-link-wrap').removeClass('hide');
                _util.set_cookie(cookie_name, 1, 3);
                model_attr = false;
            }

            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: ($wrapper.offset().top - 100)
                }, 500);
            }, 200);
            // we will trigger a change on the models of the collection to cause them to rerender
            // _data.content_collection.each(function(model){

            //     model.set('comments_collapsed', model_attr);
            // });
        },
        show_char_count: function() {
            gui.$post_char_wrap.addClass('shown');
        },
        hide_char_count: function() {
            gui.$post_char_count.text(events.get_max_chars());
            gui.$post_char_wrap.removeClass('shown');
        },
        show_post_box: function(post_type) {
            var placeholder_text = '';

            gui.$content_post_wrap.removeClass('post-photo update-status post-video');
            // Hide "add photo" and "update status" buttons
            gui.$content_post_btn_wrap.addClass('open');

            _data.post_type = post_type;

            if (post_type == 'photo') {
                // Post photo
                gui.$content_post_wrap.addClass('shown post-photo');
                placeholder_text = gui.$content_text_input.data('ph_photo');
                gui.$content_text_input.attr('placeholder', placeholder_text);
            } else if (post_type == 'video') {
                gui.$content_post_wrap.addClass('shown post-video');
                placeholder_text = gui.$content_text_input.data('ph_video');
                gui.$content_text_input.attr('placeholder', placeholder_text);
            } else if (post_type == 'story') {
                gui.$content_post_wrap.addClass('shown content-post-story');
                placeholder_text = gui.$content_text_input.data('ph_story');
                gui.$content_text_input.attr('placeholder', placeholder_text);
            } else {
                // Update status
                gui.$content_post_wrap.addClass('shown update-status');
                placeholder_text = gui.$content_text_input.data('ph_status');
                gui.$content_text_input.attr('placeholder', placeholder_text);
            }

            // Hide private option if user has no pics.
            if (GP.sdata.my_user.has_pic) {
                gui.$status_private_option.css('display', 'block');
            } else {
                gui.$status_private_option.css('display', 'none');
            }
        },
        hide_post_box: function() {
            _data.media_type = null;
            _data.media_input_status = false;
            gui.$content_post_wrap.removeClass('shown post-photo update-status post-video content-post-story');
            gui.$content_post_btn_wrap.removeClass('open');

            // hide spinner on post button
            gui.$btn_post_content.removeClass('loading');
            events.reset_errors();
            events.reset_text_fields();
        },
        animate_heart: function(elem) {
            elem.addClass('animate');
            setTimeout(function() {
                elem.removeClass('animate');
            }, 500);
        },
        show_video_upload_success: function() {
            gui.$alert_success_video.toggle();
            setTimeout(function() {
                gui.$alert_success_video.toggle();
            }, 8000);
        },
        show_image_upload_success: function() {
            gui.$alert_success_image.toggle();
            setTimeout(function() {
                gui.$alert_success_image.toggle();
            }, 8000);
        },
        update_like_count: function(model) {
            var like_data = model;

            var _content_model = _data.content_collection.find(function(model){
                return model.get('content_id') == like_data.get('content_id');
            });

            if (_content_model) {
                _content_model.set('is_liked', like_data.get('is_liked'));
                _content_model.set('like_count', like_data.get('like_count'));
            }
        },
        update_comment_count: function(model) {
            var comment_data = model;

            var _content_model = _data.content_collection.find(function(model){
                return model.get('content_id') == comment_data.get('content_id');
            });

            if (_content_model) {
                _content_model.set('comment_count', comment_data.get('comment_count'));
            }
        },
        content_view_toggle: function() {
            // don't switch views for unconverted trial users
            if (GP.sdata.my_user.unconverted_trial || GP.sdata.my_user.membership === 'PENDING_FREE') {
                return;
            }

            var view_type = $(this).data('view');

            // Update toggle buttons
            $('.nav-content-view-toggle').find('li').removeClass('active');
            $(this).closest('li').addClass('active');

            if (typeof(view_type) != 'undefined' && view_type == 'grid') {
                gui.$profile_content_media_region.addClass('grid');
                GP.sdata.my_user.view_type = 'grid';
                apis.mod_view_type('grid');
            } else {
                gui.$profile_content_media_region.removeClass('grid');
                GP.sdata.my_user.view_type = 'list';
                apis.mod_view_type('list');
            }

            _views.public_cv.render();
            _views.private_cv.render();

            GP.vent.trigger('Premium:empty_region');
            GP.vent.trigger('Premium:show_content');
            GP.vent.trigger('Premium:show_private');
        },
        update_primary: function() {
            // Find current primary pic and set to No
            var _content_model = _data.content_collection.find(function(model) {
                return model.get('media_main_pic') == 'Y';
            });

            if (_content_model) {
                _content_model.set('media_main_pic', 'N');
            }
        },
        get_public_collection: function() {
            return _data.content_collection;
        },
        get_private_collection: function() {
            return _data.private_collection;
        },
        get_profile_has_more: function() {
            return _data.profile_load_more;
        },
        get_private_has_more: function() {
            return _data.private_load_more;
        },
        get_max_chars: function() {
            return (_data.post_type == 'story') ? _content_story_max_chars : _content_status_max_chars;
        }
    };

    this.addInitializer(function() {
        _data.init();
        events.init();
    });
});
